// https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
// Converts "a.b.c" to object with keys a[b[c:val] to value of c
const getObjectValFromString = function (obj, is, value) {
  if (obj === undefined) return

  if (typeof is === 'string') {
    return getObjectValFromString(obj, is.split('.'), value)
  } else if (is.length === 1 && value !== undefined) {
    obj[is[0]] = value
    return obj[is[0]]
  } else if (is.length === 0) {
    return obj
  } else {
    return getObjectValFromString(obj[is[0]], is.slice(1), value)
  }
}

export default getObjectValFromString



// WEBPACK FOOTER //
// ./src/functions/getObjectValFromString.js